import CloseIcon from '@mui/icons-material/Close'
import {Button} from '@mui/material'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router'

interface CancelKilnChangesButtonProps {
  bypassNavigationBlocker: () => void
}

export const CancelKilnChangesButton: React.FC<CancelKilnChangesButtonProps> = ({
  bypassNavigationBlocker
}) => {
  const {t} = useTranslation()
  const navigate = useNavigate()

  return (
    <Button
      variant="outlined"
      color="secondary"
      startIcon={<CloseIcon />}
      onClick={async () => {
        bypassNavigationBlocker()
        await navigate(-1)
      }}
      sx={{border: '1px solid #E8ECF0', height: ({spacing}) => spacing(6)}}
      data-test-id="cancel-kiln-changes-btn"
    >
      {t('kilnConfig.cancel')}
    </Button>
  )
}
